import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M257.5 445.1L235.3 467.3C225.9 476.7 210.7 476.7 201.4 467.3L7 273C-2.4 263.6-2.4 248.4 7 239.1L201.4 44.7C210.8 35.3 226 35.3 235.3 44.7L257.5 66.9C267 76.4 266.8 91.9 257.1 101.2L136.6 216H424C437.3 216 448 226.7 448 240V272C448 285.3 437.3 296 424 296H136.6L257.1 410.8C266.9 420.1 267.1 435.6 257.5 445.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-left.js
// module id = CFm9
// module chunks = 144